import { useGetExpo, type ExpoView } from '@ordr-as/ordr-service-types/epos';
import { useOrdersWebSocketStore } from '../context/OrdersWebSocketStore';

/**
 * Expo board read model for a location. Like useKdsTasks, the react-query cache
 * is the source of truth: the websocket dirty-signal invalidates this query and
 * polling is only a safety net (tighter while the socket is down).
 */
export function useKdsExpo(
  locationId: number,
  options?: { enabled?: boolean },
): ReturnType<typeof useGetExpo<ExpoView>> {
  const connectionState = useOrdersWebSocketStore((s) => s.connectionState);
  return useGetExpo(locationId, {
    query: {
      enabled: options?.enabled ?? true,
      refetchInterval: connectionState === 'connected' ? 15_000 : 5_000,
      refetchOnWindowFocus: true,
    },
  });
}
